import React from 'react';
import PropTypes from 'prop-types';
import Typography from "../../../../components/Typography";
import Button from "../../../../components/Button";
import styles from '../home.module.scss'
import { useSelector } from "react-redux";
import QRCode from 'react-qr-code';

const QrScreen = ({ setScreen }) => {
    const { _2FaData } = useSelector(state => state.auth)
    return (
        <div className={styles._2fa}>
            <Typography variant={"h4"} className={"text-primary-800 pb-2.5"}>Two Factor Authentication</Typography>
            <Typography variant={"body1"} className={"px-2"}>Please use the authenticator app (such as Google
                Authenticator, Microsoft Authenticator etc) to scan the QR <nobr>code below</nobr></Typography>
            <div className={styles.qr}>
                <QRCode
                bgColor={'#ffffff'}
                fgColor={'#10AEB8'}
                    size={166}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={_2FaData?.uri}
                    viewBox={`0 0 166 166`}
                />
            </div>
            <Typography variant={"body1"} className={"px-2"}>Or enter this code into your <nobr>authenticator app</nobr>
            </Typography>
            <Typography variant={"h5"} className={"mt-[18px] text-body px-3"}>{_2FaData.key}</Typography>
            <Button onClick={() => setScreen("otp")} className={"mt-[20px]"}>Continue</Button>
        </div>
    );
};

QrScreen.propTypes = {
    setScreen: PropTypes.func
};

export default QrScreen;
